import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import Svg from 'Components/Svg';

const dragItemSource = {
    beginDrag(props) {
        return {
            type: 'area',
            from: 'left',
            areaCode: props.items.areacode
        };
    },

};

const DragItem = ({ items, connectDragSource, onDragItemClick }) => {
    const { areacode, name, icon } = items;
    return connectDragSource(
        <div className="drag-item-wrapper area" key={areacode} onClick={onDragItemClick}>
            <div className="drag-item" title={name}>
                <Svg xlinkHref={`#icon-${icon}`}/>
                <span className="name">{name}</span>
            </div>
        </div>
    ) 
}

export default DragSource('area', dragItemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
}))(DragItem)